import Vue from 'vue';
import { SmartSuggestV4 } from '../../../../declarations/request';

const searchInputAutocomplete = Vue.component('fl-search-input-autocomplete', {
    template: `
        <input class="fl-as-autocomplete-input" :style="newStyle" :value="highlightedQuery" />
    `,
    inject: ['requestService', 'HandleShopInteractionService'],
    data(): Record<string, any> {
        return {
            inputValue: '',
            inputElement: this.HandleShopInteractionService.getActiveInputField(),
            suggestionQuery: '',
            inputComputedStyle: null,
            inputRect: null,
        };
    },
    mounted(): void {
        this.HandleShopInteractionService.onInputChanged((value: string) => {
            this.$data.inputValue = value;

            if (value === '') {
                this.$data.suggestionQuery = '';
            }
        });

        this.HandleShopInteractionService.onInputTriggered((element: HTMLInputElement) => {
            this.$data.inputComputedStyle = window.getComputedStyle(element);
            this.$data.inputRect = element.getBoundingClientRect();

            if (element !== this.$data.inputElement) {
                this.$data.suggestionQuery = '';
                this.$data.inputValue = '';
            }
            this.$data.inputElement = element;
        });

        this.requestService.onResultChange((result: SmartSuggestV4.Response) => {
            this.$data.suggestionQuery = result.effectiveProductSuggestionQuery;
        });
    },
    computed: {
        highlightedQuery(): string {
            return this.$data.suggestionQuery.startsWith(this.$data.inputValue) ? this.$data.suggestionQuery : '';
        },
        newStyle(): string {
            const computedStyle = this.$data.inputComputedStyle;
            const rect = this.$data.inputRect;

            if (!computedStyle) {
                return '';
            }

            // IE calculated height always without padding, no mather the box sizing value :)))))))
            const boxSizing =
                'border-box' === computedStyle.boxSizing
                    ? (window.document as any).documentMode
                        ? 'content-box'
                        : 'border-box'
                    : 'content-box';

            return `
                position: absolute;
                top: ${this.HandleShopInteractionService.calculateTopPositionFromPositionContext(rect.top)}px;
                left: ${rect.left}px;
                height: ${computedStyle.height};
                width: ${computedStyle.width};
                font-family: ${computedStyle.fontFamily};
                font-weight: ${computedStyle.fontWeight};
                font-size: ${computedStyle.fontSize};
                line-height: ${computedStyle.lineHeight};
                padding-top: ${computedStyle.paddingTop};
                padding-right: ${computedStyle.paddingRight};
                padding-bottom: ${computedStyle.paddingBottom};
                padding-left: ${computedStyle.paddingLeft};
                border-top: ${computedStyle.borderTopWidth} ${computedStyle.borderTopStyle} ${computedStyle.borderTopColor};
                border-right: ${computedStyle.borderRightWidth} ${computedStyle.borderRightStyle} ${computedStyle.borderRightColor};
                border-bottom: ${computedStyle.borderBottomWidth} ${computedStyle.borderBottomStyle} ${computedStyle.borderBottomColor};
                border-left: ${computedStyle.borderLeftWidth} ${computedStyle.borderLeftStyle} ${computedStyle.borderLeftColor};
                border-top-right-radius: ${computedStyle.borderTopRightRadius};
                border-bottom-right-radius: ${computedStyle.borderBottomRightRadius};
                border-bottom-left-radius: ${computedStyle.borderBottomLeftRadius};
                border-top-left-radius: ${computedStyle.borderTopLeftRadius};
                text-indent: ${computedStyle.textIndent};
                outline-offset: ${computedStyle.outlineOffset || 0};
                box-sizing: ${boxSizing};
                z-index: 10000;
                pointer-events: none;
                color: rgba(0, 0, 0, 0.4);
                background-color: rgba(0, 0, 0, 0);
                -webkit-text-fill-color: initial;
                display: block;
            `;
        },
    },
});

export default searchInputAutocomplete;
